module.exports = __webpack_public_path__ + "static/icons/icon-heart-red-700880150879951c3a4fcc4f87e58010.svg";